import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import orderServices from '../../services/orders/orderservice';
import {OrderModel} from '../../models/orders/order-list-model';
import InvoicesSearch from './invoices-search';
import InvoicesDataTable from './invoices-datatable';
import AppLoading from '../app-loading/app-loading';

const GenerateInvoice = () => {

    const { t } = useTranslation();
    const [orderList, setOrderList] = useState<OrderModel[]>([]);
    const [queryText, setQueryText] = useState<string>("");
    const [openOrderFlag, setOpenOrderFlag] = useState<boolean>(true);
 
    const [loading, setLoading] = useState(false);

    function handleSearch(query: string, openOrder: boolean): void {
        setQueryText(query);
        setOpenOrderFlag(openOrder);
        setLoading(true);        
        orderServices.getOrders(query).then((response: OrderModel[]) => {
            const sortedData = [...response].sort((a, b) => b.orderID - a.orderID);
            if (openOrder) {
                const filteredData = sortedData.filter((order) => order.orderDetail.some((item) => item.pendingQuantity > 0));
                setOrderList(filteredData);

            } else {
                setOrderList(sortedData);
            }
            setLoading(false);
        }).catch(() => {
            setLoading(false); 
        });
    }
    

    return (
        <>
        <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
            <div className="col-12">                
                <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
                    <h5 className="ml-1 mb-0">{t("generateInv_header")}</h5>
                </div>
            </div>
            <InvoicesSearch onSearch={handleSearch} setLoading={setLoading} />
            <InvoicesDataTable query={queryText} openOrder={openOrderFlag} onSearch={handleSearch} data={orderList} />
        </div>
        {loading && <AppLoading />}
        </>
        
    );
};
export default GenerateInvoice;